import styled from '@emotion/styled'

const LineTextDivider = ({ text }: { text: string }) => (
  <DividerContainer>
    <LineDivider />
    <LineText>{text}</LineText>
    <LineDivider />
  </DividerContainer>
)

const DividerContainer = styled.div(({ theme }) => ({
  color: theme.colors.textMute,
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  margin: '20px 0'
}))

const LineDivider = styled.div(({ theme }) => ({
  flex: 1,
  borderBottom: `1px solid ${theme.colors.lineColor}`
}))

const LineText = styled.div(() => ({
  fontSize: '12px',
  margin: '0 8px'
}))

export default LineTextDivider
